// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseAttestationAttributeModel {
    static getAttributeTypeMap() {
        return CaseAttestationAttributeModel.attributeTypeMap;
    }
}
CaseAttestationAttributeModel.discriminator = undefined;
CaseAttestationAttributeModel.additionalProperties = false;
CaseAttestationAttributeModel.attributeTypeMap = [
    {
        "name": "attestationAttributeId",
        "baseName": "attestationAttributeId",
        "type": "number"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
];
//# sourceMappingURL=caseAttestationAttributeModel.js.map